import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";
import type { QueryType } from "@/common/types/common";

import type {
	UserLoginType,
	UserRecoverType,
	UserRegisterType,
} from "@/common/types/user";

export async function userLogin(payload: UserLoginType) {
	return await clientAxios.post(`login`, payload);
}

export async function userRecover(payload: UserRecoverType) {
	return await clientAxios.post(`recover`, payload);
}

export async function userRecoverValid(payload: UserRecoverType) {
	return await clientAxios.post(`recover/valid`, payload);
}

export async function userRecoverPassword(payload: UserRecoverType) {
	return await clientAxios.post(`recover/password`, payload);
}

export async function userRecoverCheckEmail() {
	return await clientAxios.get(`recover/check/email`);
}

export async function userProfile() {
	return await clientAxios.get(`user/profile`);
}

export async function userAdd(payload: UserRegisterType) {
	return await clientAxios.post(`user/create`, payload);
}

export async function userList(query?: QueryType) {
	const queryString = formatQueryString(query);

	return await clientAxios.get(`user/list${queryString}`);
}

export async function userUpdate(user_id: string, payload: UserRegisterType) {
	return await clientAxios.put(`user/${user_id}/update`, payload);
}

export async function userDel(user_id: string) {
	return await clientAxios.del(`user/${user_id}/delete`);
}
